export default __webpack_public_path__ + "static/media/2.76a69c4d.png";